var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('AboutMe'),_c('Skills'),_c('Experience'),_c('Education'),_c('Feedback'),_c('Contact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }